<template lang="pug">
.time-bullet
  .month {{ month }}月
  
</template>
<script>
export default {
  name: 'TimeBullet',
  props: {
    timestamp: {},
  },
  computed: {
    month() {
      return this.timestamp
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.time-bullet
  width: 100%
  text-align: center
  .month
    width: 100%
    font-size: pxToRem(32)
    color: black
    font-family: $ff-cn
</style>
